import React, { useState } from "react";
import { actionUseGift } from "../../../api/postApi";
import { useDispatch } from "react-redux";
import { globalTrigger, notice } from "../../../redux/action/action";
import { useTranslation } from "react-i18next";

const UsedRewardCard = ({
  bonusName,
  usedTime,
  playBet,
  isuse,
  usedGame,
  itemProps,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.${key}`);
  // isuse 狀態顯示在前端,0:可轉點,1:鎖定中,else:已凍結
  const { uid } = itemProps || {};
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  const handleUseGift = (goodUid) => {
    setButtonLoading(true);
    actionUseGift({
      good_uid: goodUid,
    })
      .then((data) => {
        dispatch(notice(i18n("Successfully used the gift"), "success"));
        dispatch(globalTrigger());
        dispatch({ type: "GET_BALANCE" });
      })
      .catch((err) => {})
      .finally(() => {
        setButtonLoading(false);
      });
  };
  return (
    <section className="bg-transaction-card dark:bg-base-light-dark p-[15px] rounded-[5px] flex flex-col gap-[10px] mb-[20px] !min-w-[95%] md:min-w-none">
      <span className="text-transaction-text dark:text-light-white text-xl tracking-tight font-medium">
        {bonusName}
      </span>
      {/* <span className="font-light text-sm tracking-tight text-light-text">
        {i18n("Bet Amount/Thawed Bet")}
        <span className="text-base text-transaction-text dark:text-light-white font-medium">
          {playBet}
        </span>
      </span> */}
      {/* <span className="font-light text-sm tracking-tight text-light-text">
        {i18n("Game Used")} <span>{usedGame}</span>
      </span> */}
      <span className="font-light text-sm tracking-tight text-light-text">
        {i18n("Time Used")} <span>{usedTime}</span>
      </span>
      <button
        className={`${
          isuse !== 0 ? "!bg-gray-500" : ""
        } py-[10px] bg-main-color text-light-white font-semibold hover:bg-hover-main-bg text-lg rounded-[5px]`}
        type="button"
        onClick={() => {
          handleUseGift(uid);
        }}
        disabled={buttonLoading || isuse != 0}
      >
        {isuse == 0 ? i18n("Available") : isuse == 1 && i18n("Used")}{" "}
      </button>
    </section>
  );
};

export default UsedRewardCard;
